import { __assign, __rest } from "tslib";
import React from 'react';
import Position from './Position';
/** @type {any} */
var PinBL = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Position, __assign({ bottom: 0, left: 0, position: "absolute", ref: ref }, props), children));
});
export default PinBL;
